import React from "react";
import PropTypes from "prop-types";

import {
  Wrapper,
  Description,
  DescriptionWrapper,
  Tagline,
  Underline,
  EventDate,
} from "./styles";

const Blurb = ({ description }) => (
  <Wrapper>
    <div>
      <Tagline className="serif">
        the next generation of creative thinkers.
      </Tagline>
      <EventDate>
        <b>Spring / Summer 2022</b>
      </EventDate>
    </div>
    <DescriptionWrapper>
      {description.map((pText, index) => (
        // eslint-disable-next-line
        <Description key={index} dangerouslySetInnerHTML={{ __html: pText }} />
      ))}
    </DescriptionWrapper>
  </Wrapper>
);

Blurb.propTypes = {
  description: PropTypes.arrayOf(PropTypes.string),
  tagline: PropTypes.string,
  eventDate: PropTypes.string,
};
Blurb.defaultProps = {
  description: [
    // eslint-disable-next-line
    `<i>Art emerges as more essential than ever</i> in this era of multiple global climate crises, pervasive racial and social injustice, political calamity, and a loss of a sense of community imposed on us by a traumatic pandemic.`,
    `The work of these artists, designers, filmmakers, educators and curators demonstrates how art disrupts in the most benevolent sense, awakens us to the present moment, and contributes to our shared becoming, that we might imagine things otherwise and become more fully human.`,
    `MICA GRAD SHOW 2022 will virtually showcase the culminating work of more than 130 MFA and MA graduate students from the College's internationally renowned programs. Opportunities for additional ticketed exhibitions and events opening to the public this Spring and Summer 2022 coming soon.`,
  ],
  tagline: "The Next Generation of Creative Thinkers",
  eventDate: "Spring / Summer 2022",
};

export default Blurb;



// WEBPACK FOOTER //
// ./src/components/Blurb/Blurb.jsx